import type { Board } from "@/model/board";
import { useGlobalI18n } from "@/translations/i18n";

import { BoardLocation } from "./BoardLocation";

const { t } = useGlobalI18n();

const prefix = "$sel:";

export class SelectionLocation extends BoardLocation {
  constructor(private cardIds: string[]) {
    super();
  }

  static ofId(id: string) {
    if (id.startsWith(prefix)) {
      return new SelectionLocation(id.substring(prefix.length).split(","));
    }
  }

  override id() {
    return prefix + this.cardIds.join(",");
  }

  override get name() {
    return t("label.overviewModal.selection");
  }

  override cards(board: Board) {
    return this.cardIds.map((id) => board.cards[id]);
  }
}
